var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"justify-center":""}},[_c('v-btn',{attrs:{"color":"info","href":"mailto:info@thrasker.com"}},[_vm._v("\n    Contact us!\n  ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }